import { createSelector } from '@ngrx/store';
import {AppState} from '../core.state';
import { SportEventState } from './sport-events.model';


export const selectSportEventState = createSelector(
  (state: AppState) => state.sport_events,
  (sport_events: SportEventState) => sport_events
);

export const selectSportEventList = createSelector(selectSportEventState, (state: SportEventState) => state.sportEvent);

export const selectSportEventLoading = createSelector(selectSportEventState, (state: SportEventState) => state.sportEventLoading);

export const selectSportEventLoaded = createSelector(selectSportEventState, (state: SportEventState) => state.sportEventLoaded);
